import { render, staticRenderFns } from "./TemplateTree.vue?vue&type=template&id=00d8048e&scoped=true&"
import script from "./TemplateTree.vue?vue&type=script&lang=js&"
export * from "./TemplateTree.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTree.vue?vue&type=style&index=0&id=00d8048e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8048e",
  null
  
)

export default component.exports